import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { IndustryStoreService } from '@franbase/backend/industry/data-access';
import { UserItemComponent } from '@franbase/frontend/shared/ui/user-item';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { MainMenuComponent } from '../main-menu/main-menu.component';

@Component({
  selector: 'franbase-header',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    NzInputModule,
    SvgIconComponent,
    NzDropDownModule,
    NzAffixModule,
    NzMenuModule,
    UserItemComponent,
    RouterModule,
    NzTabsModule,
    MainMenuComponent,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [IndustryStoreService]
})

export class HeaderComponent {

  IndustryStoreService = inject(IndustryStoreService);
  router = inject(Router);

  menuIsVisible = false;

  constructor() {
    this.IndustryStoreService.data$;
  }

  toggleMenu() {
    this.menuIsVisible = !this.menuIsVisible;
  }

  closeMenu(value: boolean) {
    this.menuIsVisible = value;
  }
}
